import * as React from "react";
const SvgButtonQr = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "Qr-Code-Scan--Streamline-Streamline-3.0",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Qr Code Scan Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "qr-code-scan"), /* @__PURE__ */ React.createElement("path", {
	d: "M5.25 5.25h3v3h-3Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.25 15.75h3v3h-3Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.75 5.25h3v3h-3Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m5.25 12.75 6 0 0 1.5",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m14.25 14.25 0 4.5 4.5 0 0 -4.5 -1.5 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m11.25 17.25 0 1.5",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m11.25 5.25 0 4.5 1.5 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m15.75 11.25 3 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M0.75 6V2.25a1.5 1.5 0 0 1 1.5 -1.5H6",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 0.75h3.75a1.5 1.5 0 0 1 1.5 1.5V6",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23.25 18v3.75a1.5 1.5 0 0 1 -1.5 1.5H18",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6 23.25H2.25a1.5 1.5 0 0 1 -1.5 -1.5V18",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgButtonQr as ReactComponent };
